import './LoadingSpinner.css';

export const LoadingSpinner = ({ fullPage = false }) => (
  <div className={`loading-wrapper ${fullPage ? 'loading-wrapper--full' : ''}`}>
    <div className="loading-spinner">
      <div className="spinner-ring"></div>
      <div className="spinner-dot"></div>
    </div>
  </div>
);
